// Mock data for Maison Bengal & Coon website

export const siteInfo = {
  name: "Maison Bengal & Coon",
  tagline: "Élevage familial de Maine Coons LOOF",
  location: "Plounéour-Ménez, Finistère, Bretagne",
  phone: "06 70 56 27 98",
  email: "maisonbengalcoon@gmail.com",
  siret: "988 915 898 00015",
  owners: ["Liza GUENODEN", "Paol LENNE"]
};

export const heroContent = {
  title: "Maison Bengal & Coon",
  subtitle: "Élevage familial de Maine Coons",
  description: "En plein cœur du Finistère, notre élevage familial à Plounéour-Ménez élève avec passion des Maine Coons LOOF, sélectionnés avec soin pour offrir des compagnons équilibrés, élégants et affectueux."
};

export const aboutContent = {
  title: "À propos de nous",
  description: "Nous sommes Liza et Paol, titulaires de l'ACACED et passionnés par le monde félin. À travers Maison Bengal & Coon, nous avons fait le choix d'un élevage responsable, fondé sur le respect, le bien-être et la qualité de chaque chat que nous élevons.",
  highlights: [
    { number: "4", label: "Femelles reproductrices", description: "Sélectionnées avec exigence à travers la France, alliant excellence génétique, santé parfaite et tempérament exemplaire." },
    { number: "2", label: "Mâles reproducteurs", description: "Soigneusement choisis pour leur santé, leur tempérament et leur génétique, essentiels à la qualité de nos lignées." },
    { number: "LOOF", label: "Chats enregistrés", description: "Tous nos chats sont enregistrés au Livre Officiel des Origines Félines." }
  ]
};

export const elevageContent = {
  title: "Notre Élevage",
  description: "Situé à Plounéour-Ménez, au cœur des Monts d'Arrée, notre élevage bénéficie d'un cadre naturel préservé, idéal pour l'épanouissement de nos Maine Coons.",
  features: [
    "Environnement sain et équilibré",
    "Socialisation soigneuse des chatons",
    "Suivi vétérinaire rigoureux",
    "Tests ADN systématiques",
    "Partenariat Royal Canin"
  ]
};

export const maineCoonContent = {
  title: "Le Maine Coon",
  subtitle: "Le gentil géant",
  description: "Originaire de l'État du Maine aux États-Unis, le Maine Coon est apprécié pour sa taille impressionnante, son aspect rustique et son tempérament doux.",
  characteristics: [
    { title: "Origines", text: "Issue d'une évolution naturelle, cette race s'est adaptée aux climats rigoureux grâce à sa morphologie robuste et sa fourrure dense." },
    { title: "Tempérament", text: "Malgré son gabarit imposant, le Maine Coon est un chat affectueux, sociable et équilibré, souvent surnommé le gentil géant." },
    { title: "Intelligence", text: "Intelligent et curieux, il apprécie la compagnie de sa famille sans être envahissant et s'entend avec les enfants et autres animaux." },
    { title: "Apparence", text: "Reconnaissable à son physique majestueux, ses grandes oreilles ornées de plumets et son regard expressif." }
  ],
  health: {
    title: "Santé & prévention chez le Maine Coon",
    description: "Chez le Maine Coon, la prévention est essentielle. Les principales pathologies surveillées sont la cardiomyopathie hypertrophique (HCM), la dysplasie des hanches (HD), l'atrophie musculaire spinale (SMA), la PKDef et plus rarement la PKD.",
    tests: [
      "Tests ADN systématiques sur nos reproducteurs pour la HCM, la SMA et la PKDef",
      "Suivi vétérinaire rigoureux : chatons vaccinés, identifiés et vermifugés",
      "Carnet de santé à jour et certificat vétérinaire remis au départ",
      "Échographies cardiaques et rénales en cas de doute ou nécessité",
      "Radiographies HD en cas de suspicion de dysplasie des hanches"
    ]
  },
  nutrition: {
    title: "Alimentation du Maine Coon",
    description: "Le Maine Coon, à la croissance lente et au gabarit imposant, nécessite une alimentation adaptée et évolutive. Nous travaillons en partenariat avec Royal Canin pour optimiser la qualité des apports nutritionnels.",
    points: [
      "Alimentation chaton (kitten) jusqu'à environ 15 mois",
      "Transition progressive vers alimentation adulte",
      "Croquettes premium à base de protéines animales de haute qualité",
      "Eau fraîche accessible en permanence",
      "Surveillance attentive des apports alimentaires"
    ]
  },
  fullText: `Originaire de l'État du Maine aux États-Unis, la race Maine Coon est appréciée pour sa taille impressionnante, son aspect rustique et son tempérament doux. Issue d'une évolution naturelle, cette race s'est adaptée aux climats rigoureux grâce à sa morphologie robuste, sa fourrure dense et sa longue queue touffue.

Malgré son gabarit imposant, le Maine Coon est un chat affectueux, sociable et équilibré, souvent surnommé le gentil géant. Intelligent et curieux, il apprécie la compagnie de sa famille sans être envahissant et s'entend généralement très bien avec les enfants et les autres animaux.

Reconnaissable à son physique majestueux, ses grandes oreilles ornées de plumets et son regard expressif, le Maine Coon allie élégance et puissance. Adaptable et facile à vivre, il s'épanouit aussi bien en maison qu'en appartement, faisant de lui un compagnon fidèle et attachant.`
};

export const galleryImages = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1606213651356-0272cc0becd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxNYWluZSUyMENvb24lMjBjYXR8ZW58MHx8fHwxNzY3NDg1NDczfDA&ixlib=rb-4.1.0&q=85",
    alt: "Maine Coon - Maison Bengal & Coon",
    category: "maine-coon"
  },
  {
    id: 2,
    src: "https://images.unsplash.com/photo-1695591334295-f826fd974265?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxNYWluZSUyMENvb24lMjBjYXR8ZW58MHx8fHwxNzY3NDg1NDczfDA&ixlib=rb-4.1.0&q=85",
    alt: "Maine Coon - Maison Bengal & Coon",
    category: "maine-coon"
  },
  {
    id: 3,
    src: "https://images.unsplash.com/photo-1675450062716-1d9d1bbebafb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxNYWluZSUyMENvb24lMjBjYXR8ZW58MHx8fHwxNzY3NDg1NDczfDA&ixlib=rb-4.1.0&q=85",
    alt: "Maine Coon - Maison Bengal & Coon",
    category: "maine-coon"
  },
  {
    id: 4,
    src: "https://images.unsplash.com/photo-1624477737871-2e6583e7deb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxNYWluZSUyMENvb24lMjBjYXR8ZW58MHx8fHwxNzY3NDg1NDczfDA&ixlib=rb-4.1.0&q=85",
    alt: "Maine Coon - Maison Bengal & Coon",
    category: "maine-coon"
  }
];

export const guestbookEntries = [
  {
    id: "1",
    name: "Marie D.",
    date: "2025-01-15",
    message: "Nous avons adopté notre petit Maine Coon il y a 3 mois et c'est un véritable bonheur ! Merci à Liza et Paol pour leur professionnalisme et leur suivi.",
    rating: 5
  },
  {
    id: "2",
    name: "Jean-Pierre L.",
    date: "2024-12-20",
    message: "Notre Maine Coon est magnifique et parfaitement socialisé. On sent vraiment l'amour et le soin apportés aux chatons. Élevage de confiance !",
    rating: 5
  },
  {
    id: "3",
    name: "Sophie et Marc",
    date: "2024-11-08",
    message: "Deuxième adoption chez Maison Bengal & Coon et toujours aussi satisfaits. Des chats en excellente santé et au caractère adorable.",
    rating: 5
  }
];

export const images = {
  logo: "https://customer-assets.emergentagent.com/job_catelevage/artifacts/ytfpq0r7_logo%20bengal.avif",
  maineCoon1: "https://images.unsplash.com/photo-1606213651356-0272cc0becd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxNYWluZSUyMENvb24lMjBjYXR8ZW58MHx8fHwxNzY3NDg1NDczfDA&ixlib=rb-4.1.0&q=85",
  maineCoon2: "https://images.unsplash.com/photo-1695591334295-f826fd974265?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxNYWluZSUyMENvb24lMjBjYXR8ZW58MHx8fHwxNzY3NDg1NDczfDA&ixlib=rb-4.1.0&q=85",
  maineCoon3: "https://images.unsplash.com/photo-1675450062716-1d9d1bbebafb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxNYWluZSUyMENvb24lMjBjYXR8ZW58MHx8fHwxNzY3NDg1NDczfDA&ixlib=rb-4.1.0&q=85",
  maineCoon4: "https://images.unsplash.com/photo-1624477737871-2e6583e7deb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxNYWluZSUyMENvb24lMjBjYXR8ZW58MHx8fHwxNzY3NDg1NDczfDA&ixlib=rb-4.1.0&q=85",
  brittany1: "https://images.unsplash.com/photo-1663866655327-8935ffba50eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxCcml0dGFueSUyMEZyYW5jZSUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3Njc0ODU0OTR8MA&ixlib=rb-4.1.0&q=85",
  brittany2: "https://images.unsplash.com/photo-1653575018227-b4d75bbb2cdf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxCcml0dGFueSUyMEZyYW5jZSUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3Njc0ODU0OTR8MA&ixlib=rb-4.1.0&q=85",
  royalCanin: "https://www.royalcanin.com/cdn-cgi/image/width=200,format=auto/assets/images/royal-canin-logo.svg"
};

export const legalContent = {
  mentionsLegales: `Conformément aux dispositions des articles 6-III et 19 de la Loi n°2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, dite L.C.E.N., il est porté à la connaissance des utilisateurs et visiteurs, ci-après l'« Utilisateur », du site de Maison Bengal & Coon, ci-après le « Site », les présentes mentions légales.

La connexion et la navigation sur le Site par l'Utilisateur implique l'acceptation intégrale et sans réserve des présentes mentions légales.

Celles-ci sont accessibles à tout moment sur le Site à la rubrique « Mentions légales ».

ÉDITEUR DU SITE

Maison Bengal & Coon
Entreprise individuelle
Dirigeante : Madame Liza GUENODEN
Directeur de publication : Monsieur Paol LENNE; Madame Liza GUENODEN
SIRET : 988 915 898 00015 enregistré au RCS de Brest
Code APE : 0149Z
Email : maisonbengalcoon@gmail.com
Téléphone : 06 70 56 27 98

HÉBERGEUR DU SITE

Le site est hébergé par la société IONOS SARL
7 place de la Gare, BP 70109
57201 Sarreguemines Cedex – France
Site : www.ionos.fr
Tél. : 09 70 80 89 11

ACCÈS AU SITE

Le Site est accessible en tout lieu, 7j/7, 24h/24, sauf cas de force majeure, interruption programmée ou non, pouvant découler d'une nécessité de maintenance.

En cas de modification, interruption ou suspension du Site, l'éditeur ne saurait être tenu responsable.

COLLECTE DE DONNÉES

Le Site assure à l'Utilisateur une collecte et un traitement des informations personnelles dans le respect de la vie privée, conformément à la loi n°78-17 du 6 janvier 1978, relative à l'informatique, aux fichiers et aux libertés.

L'Utilisateur peut exercer ses droits d'accès, de rectification, de suppression et d'opposition par e-mail à l'adresse suivante : maisonbengalcoon@gmail.com

LISTE D'OPPOSITION AU DÉMARCHAGE TÉLÉPHONIQUE – BLOCTEL

Conformément à l'article L.223-2 du Code de la consommation, l'Utilisateur peut s'inscrire gratuitement sur la liste d'opposition au démarchage téléphonique : www.bloctel.gouv.fr

RÈGLEMENT EN LIGNE DES LITIGES (RLL) – COMMISSION EUROPÉENNE

En application du Règlement (UE) n°524/2013, la Commission européenne met à disposition une plateforme de règlement des litiges en ligne : https://ec.europa.eu/consumers/odr

DROITS DE PROPRIÉTÉ INTELLECTUELLE

Toute utilisation, reproduction, diffusion, commercialisation ou modification de tout ou partie du Site, sans autorisation préalable écrite de Madame Liza GUENODEN, est interdite et pourra entraîner des poursuites judiciaires.

UTILISATION DU SITE

La consultation et l'utilisation du Site sont subordonnées à l'acceptation des Conditions Générales de Vente, accessibles depuis la page dédiée.

MÉDIATION DES LITIGES DE LA CONSOMMATION

Conformément aux articles L.611-1 à L.611-3 et R.612-1 à R.612-2 du Code de la consommation, tout consommateur peut recourir gratuitement à un médiateur de la consommation.

Le médiateur désigné est :
Association AMBO
Maison des associations Jean Le Coutaller
5 place Louis Bonneaud
56100 Lorient

CRÉDIT PHOTO

Les visuels utilisés sur le site sont soit la propriété exclusive de Maison Bengal & Coon, soit issus de banques d'images libres de droit.`,

  politiqueConfidentialite: `Le site web Maison Bengal & Coon est détenu et exploité par Maison Bengal & Coon, représentée par Madame Liza GUENODEN, qui agit en tant que responsable du traitement de vos données personnelles.

Nous avons mis en place la présente politique de confidentialité afin d'expliquer comment nous collectons, utilisons et protégeons vos données personnelles.

En naviguant sur ce site, vous acceptez les pratiques décrites ci-dessous.

DONNÉES PERSONNELLES COLLECTÉES

Lors de votre navigation sur le Site, certaines informations peuvent être collectées automatiquement :
• Type de navigateur
• Adresse IP
• Fuseau horaire
• Cookies installés sur votre appareil
• Pages consultées
• Interactions avec le site

Ces données sont collectées à des fins statistiques, techniques et de sécurité.

Nous collectons également les données personnelles que vous nous fournissez volontairement via les formulaires de contact ou de demande d'informations : nom, prénom, téléphone, adresse e-mail, etc.

FINALITÉ DU TRAITEMENT

Les données sont collectées uniquement pour :
• Assurer le bon fonctionnement du site
• Répondre aux demandes de contact
• Gérer la relation client
• Protéger les intérêts légitimes de l'entreprise (sécurité, prévention des abus)

Aucune donnée n'est vendue ni utilisée à des fins commerciales non prévues.

VOS DROITS

Conformément au RGPD, vous disposez des droits suivants :
• Droit d'accès
• Droit de rectification
• Droit à l'effacement
• Droit à la limitation du traitement
• Droit d'opposition
• Droit à la portabilité
• Droit de retirer votre consentement à tout moment

Pour exercer vos droits : maisonbengalcoon@gmail.com

LIENS EXTERNES

Le Site peut contenir des liens vers des sites tiers. Maison Bengal & Coon ne saurait être tenue responsable des politiques de confidentialité de ces sites externes.

SÉCURITÉ DES DONNÉES

Les données sont stockées sur des serveurs sécurisés. Des mesures techniques et organisationnelles sont mises en œuvre pour limiter tout accès non autorisé.

Toutefois, aucune transmission de données via Internet n'est totalement sécurisée.

DIVULGATION LÉGALE

Les données personnelles pourront être divulguées si la loi l'exige (obligation légale, procédure judiciaire, demande d'une autorité compétente).

CONTACT

Pour toute question relative à la présente politique de confidentialité ou à vos données personnelles : maisonbengalcoon@gmail.com`
};

export const guestbookPassword = "bengal2026";
